var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7H5.5",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5L5.5 7L7.5 9",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4799 10.5C11.7229 11.6846 10.6023 12.5919 9.28602 13.0858C7.96978 13.5796 6.5289 13.6334 5.1795 13.2391C3.83009 12.8447 2.6449 12.0236 1.80169 10.8987C0.958474 9.77379 0.502686 8.40584 0.502686 7C0.502686 5.59416 0.958474 4.22622 1.80169 3.10133C2.6449 1.97644 3.83009 1.15526 5.1795 0.760932C6.5289 0.366607 7.96978 0.420402 9.28602 0.914249C10.6023 1.40809 11.7229 2.31537 12.4799 3.5",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrom);
export default __webpack_public_path__ + "static/media/from.6aeaa9bb6e1c7989cefd4586f87115ec.svg";
export { ForwardRef as ReactComponent };